import NetworkingAnimation from '../../assets/animations/Networking.json';
import { Box, Typography } from '@mui/material';
import Lottie from 'lottie-react';


export const Networking = () => {

    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100vw',
        }}
        >
            <div style={{ display: "flex", flexDirection: 'column', alignItems: 'center' }}>
                <Lottie
                    animationData={NetworkingAnimation}
                    loop={true}
                    size={500}
                    style={{ height: '', width: '500px' }}
                />
            </div>
        </Box>
    );
};